export { default } from './propsToClassKey';